import AssessmentPartCover from "./AssessmentPartCover";

export default AssessmentPartCover;
